import { useState } from 'react';
import addCircleIcon from '../assets/add-circle.svg';
import {
    PublicationChoiceModal,
    type PublicationPresetSchedule,
} from '../publications/Modals/PublicationChoiceModal';
import { IconButton } from '../components/Button';

const COMPACT_CLASSNAME =
    'flex items-center rounded-full border border-primary bg-primary p-1 text-[11px] font-medium text-dark-gray';

type Props = Readonly<{
    presetSchedule?: PublicationPresetSchedule;
    compact?: boolean;
    label?: string;
    excludeFromTabOrder?: boolean;
}>;

export function AddPublicationButton({
    presetSchedule,
    compact = false,
    label,
    excludeFromTabOrder = false,
}: Props = {}) {
    const [isPublicationChoiceOpen, setIsPublicationChoiceOpen] = useState(false);
    const text = label ?? (compact ? 'Créer' : 'Créer une publication');
    const tabIndex = excludeFromTabOrder ? -1 : undefined;
    const openModal = () => setIsPublicationChoiceOpen(true);

    return (
        <>
            <PublicationChoiceModal
                isOpen={isPublicationChoiceOpen}
                onRequestClose={() => setIsPublicationChoiceOpen(false)}
                presetSchedule={presetSchedule}
            />
            {compact ? (
                <button
                    type="button"
                    tabIndex={tabIndex}
                    onClick={openModal}
                    className={COMPACT_CLASSNAME}
                >
                    <img src={addCircleIcon} className="w-4" alt={text} aria-hidden />
                    {text}
                </button>
            ) : (
                <IconButton
                    type="button"
                    tabIndex={tabIndex}
                    onClick={openModal}
                    label={text}
                    icon={addCircleIcon}
                />
            )}
        </>
    );
}
